import styled from 'styled-components';

export const Animated = styled.div``;
